import classNames from 'clsx';
import React, { ForwardedRef, forwardRef, MouseEvent, ReactElement } from 'react';

import styles from './Label.css';

interface IProps {
    children: ReactElement | string; 
    className?: string;
    onClick?(event?: MouseEvent): void;
}

export const Label = forwardRef(function Label ({ children, className = '', onClick }: IProps, ref: ForwardedRef<HTMLDivElement>): ReactElement {
    return (
        <div className={classNames(styles.root, className)} ref={ref} onClick={onClick}>
            {children}
        </div>
    );
});
